import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PcpFormDataDto } from 'enrollment/features/Plans/PlanCard/types';

const initialState: PcpFormDataDto = {
  pcpCode: '',
  pcpName: '',
  existingPatient: false,
  dependents: [],
};

const ProviderInfoSlice = createSlice({
  name: 'SET_PROVIDER_INFO',
  initialState,
  reducers: {
    setProviderInfo: (state, { payload }: PayloadAction<PcpFormDataDto>) => {
      const { pcpCode, pcpName, existingPatient, dependents } = payload;
      state.pcpCode = pcpCode;
      state.pcpName = pcpName;
      state.existingPatient = existingPatient;
      state.dependents = dependents || [];
    },
  },
});

const { reducer, actions } = ProviderInfoSlice;

// Actions
export const { setProviderInfo } = actions;

export const ProviderInfoReducer = reducer;
